import { Box } from "@material-ui/core";
import React from "react";
import LiquidityStakingContainer from "./liquiditystaking";

const EarnContainer = (props) => {

  return (
    <Box id="Earn" className="tab-pane in active">
      <Box className="tab-content">
        <LiquidityStakingContainer></LiquidityStakingContainer>
      </Box>
    </Box>
  );
};

export default EarnContainer;
